import React from 'react';

const DiscussionModal = ({
  selectedTopicIndex,
  discussionTopic,
  storedUsername,
  newResponse,
  setNewResponse,
  discussionLoading,
  groupedResponses,
  handleLikeDiscussionResponse,
  onClose,
  onSubmit,
}) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 p-4 flex items-center justify-center">
      <div className="bg-white w-full max-w-md rounded-2xl p-6">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold">Join Discussion</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        <div className="mb-3 text-sm text-gray-600">
          Posting as <span className="font-medium text-gray-900">{storedUsername}</span>
        </div>

        <div className="mb-3 text-sm rounded-xl bg-blue-50 border border-blue-200 px-3 py-2">
          Responding to: {discussionTopic}
        </div>

        <form onSubmit={onSubmit}>
          <textarea
            rows={4}
            placeholder="Share your thoughts…"
            value={newResponse.response}
            onChange={(e) =>
              setNewResponse((prev) => ({ ...prev, response: e.target.value }))
            }
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <div className="mt-3 flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg bg-gray-200 text-gray-800"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={discussionLoading || !newResponse.response.trim()}
              className="px-4 py-2 rounded-lg bg-blue-600 text-white disabled:opacity-50"
            >
              {discussionLoading ? 'Posting…' : 'Post'}
            </button>
          </div>
        </form>

        {/* Minimal response list for that topic */}
        <div className="mt-6">
          <div className="text-sm font-medium text-gray-900 mb-2">Responses</div>
          <div className="space-y-3 max-h-64 overflow-auto">
            {(groupedResponses[selectedTopicIndex] || []).map((resp) => (
              <div key={resp._id} className="bg-gray-50 rounded-xl p-3">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-semibold text-gray-900">{resp.username}</div>
                  <button
                    onClick={() => handleLikeDiscussionResponse(resp._id)}
                    className="text-gray-500 hover:text-red-600 text-sm flex items-center gap-1"
                  >
                    <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-current">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                      />
                    </svg>
                    <span>{resp.likes || 0}</span>
                  </button>
                </div>
                <p className="text-sm text-gray-800 mt-1">{resp.response}</p>
              </div>
            ))}
            {(groupedResponses[selectedTopicIndex] || []).length === 0 && (
              <div className="text-sm text-gray-500">No responses yet.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscussionModal;
